module.exports = __webpack_public_path__ + "static/media/intro.3f0768cc.mp3";